import { ArrowUpRight } from "lucide-react";
import { SITE } from "@/constants/site";
import { Reveal } from "@/components/Reveal";
import { SectionTag } from "@/components/SectionTag";
import { useLang } from "@/i18n/LangContext";

export const PainPoints = () => {
  const { t } = useLang();
  const p = t.home.painPoints;
  return (
  <section className="px-5 md:px-10 py-24 md:py-32" data-testid="pain-points">
    <div className="mx-auto max-w-7xl">
      <div className="max-w-3xl">
        <SectionTag>{p.tag}</SectionTag>
        <Reveal delay={0.1}>
          <h2 className="mt-5 font-display text-3xl md:text-5xl font-bold tracking-tight text-balance">
            {p.h2}
          </h2>
        </Reveal>
      </div>

      <div className="mt-14 md:mt-20 border-t border-ink/8">
        {p.situations.map((s, i) => (
          <Reveal key={i} delay={i * 0.06}>
            <div className="group grid gap-3 md:grid-cols-[5rem_1fr] items-start border-b border-ink/8 py-8 md:py-10 transition-colors duration-500 hover:bg-white/50 md:px-6 md:-mx-6 rounded-none md:rounded-3xl">
              <span className="font-display text-sm font-bold text-terracotta-deep/60 transition-colors duration-300 group-hover:text-terracotta-deep">
                {String(i + 1).padStart(2, "0")}
              </span>
              <p className="text-lg md:text-2xl leading-snug">
                <span className="font-display font-bold tracking-tight">{s.bold}</span>{" "}
                <span className="text-plum/70">{s.rest}</span>
              </p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15} className="mt-14">
        <div className="flex flex-col md:flex-row md:items-center gap-8 rounded-3xl bg-sand/70 p-8 md:p-12">
          <p className="flex-1 text-base md:text-lg leading-relaxed text-plum/90">
            {p.bannerA}{" "}
            <strong className="font-semibold text-ink">{p.bannerStrong}</strong>.
          </p>
          <a
            href={SITE.calendly}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="painpoints-cta-rdv"
            className="group inline-flex shrink-0 items-center gap-2.5 rounded-full bg-terracotta px-7 py-4 text-sm font-semibold text-ink transition-colors duration-300 hover:bg-terracotta-dark"
          >
            {p.bannerCta}
            <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </div>
      </Reveal>
    </div>
  </section>
  );
};
